export const FEATURE_TAGS_STORAGE_KEY = 'gfknewron-feature-toggle';
export const FEATURE_TAGS_SEPARATOR = ',';
export const SAVED_VIEW_KEY = 'savedViewKey_marketPortfolio';

export const Proposition = {
  Market: 'market',
  DistributionPanel: 'dp',
} as const;
export const MARKET_ROUTE_PREFIX = {
  Mo: 'mo',
  Mi: 'mi',
  Ml: 'ml',
  Market: 'market',
} as const;

export const DP_ROUTE_PREFIX = {
  Dpo: 'dpo',
  Dpi: 'dpi',
  Dpl: 'dpl',
  Dp: 'dp',
} as const;

export const ROUTE_PREFIX = { ...MARKET_ROUTE_PREFIX, ...DP_ROUTE_PREFIX } as const;

export const MarketPrefixTypes = Object.values(MARKET_ROUTE_PREFIX) as string[];
export const DPPrefixTypes = Object.values(DP_ROUTE_PREFIX) as string[];
